import React, { useEffect, useState } from "react";
import { Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter,Box } from "@chakra-ui/react";
import "./payNow.css";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import {  generateUniqueId, maskedAccNumber, txnTypeMethod } from "./helper";
import { fetchAsyncTransactionOtp } from "redux/paymentSlice";
import { validateTranscationOtpField } from "./validations";
import { Col, Form, Row } from "react-bootstrap";
import CustomPopover from "components/customPopover/customPopover";
import prJson from "components/jsonData/purchase.json";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { RiRefreshLine } from "react-icons/ri";
import usePaymentLimit from "./api/usePaymentLimit";
import usePaidByDetails from "./api/usePaidByDetails";
import useVendorBankDetails from "./api/useVendorBankDetails";
import SelectField from "../component/selectField";
import useCreateOtp from "./api/useCreateOtp";
import useFetchPaymentDetails from "./api/useFetchPaymentDetails";
import useFetchTransactionInquiry from "./api/useTransactionInquiry";

const PayNowDetails = ({
  closeModal,
  isOpen,
  requestedAmount,
  expenseId,
  vendorId,
  poNo,
  orderDate,
  moduleId,
  expenseType,
  paymentId,
  accountUser,
  autoCount
}) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [method,setMethod] = useState("");
  const [otp,setOtp] = useState("");
  const [remarks,setRemarks] = useState("")
  const [isLoading, setIsLoading] = useState(false);
  const [bankValue,setBankValue] = useState("")

  const [receiverData, setReceiverData] = useState({
    uniqueId:generateUniqueId(),
    ifsc: "",
    creditAcc: "",
    amount: requestedAmount,
    payeeName: "",
  });

  const {senderData} = usePaidByDetails(accountUser)
  const {limits} = usePaymentLimit(moduleId);
  const {banks,bankOptions,vendor} = useVendorBankDetails(vendorId);
  const { isOtpLoading, otpIsSuccess,setOtpIsSuccess, handleProcedBtn } = useCreateOtp(senderData, receiverData, requestedAmount, method, limits);
  const { paymentData, refetch: refetchPaymentDetails } = useFetchPaymentDetails(expenseId, paymentId);
  const { fetchTransactionInquiry, isLoadingInquiry } = useFetchTransactionInquiry(paymentData, senderData, refetchPaymentDetails);


  useEffect(()=>{
    if(paymentData && paymentData?.vBnk){
      setBankValue(paymentData?.vBnk)
    }
    else if(bankOptions?.length > 0){
      setBankValue(bankOptions[0]?.value)
    }
  },[paymentData,bankOptions]);

  useEffect(() => {
    if (bankValue) {
      const selectedBank = banks.find(bank => bank._id === bankValue);
      if (selectedBank) {
        const ifscLower = selectedBank?.ifc ? selectedBank?.ifc.toLowerCase() : '';
        let ifc = selectedBank?.ifc;
        if(ifscLower.startsWith('icic')){
          ifc="ICIC0000011"
          setMethod('ICICI')
        }
        setReceiverData((prevData) => ({
          ...prevData,
          ifsc: ifc,
          creditAcc: selectedBank.acNo,
          payeeName: selectedBank.hol || vendor?.name,
        }));
      }
    }
  }, [bankValue]);
 
  
  const fetchVerifyOtpApi = (data)=>{
    setIsLoading(true)
    dispatch(fetchAsyncTransactionOtp({data}))
      .then((res) => {
        if (res?.payload && res?.payload?.payment) {
          addToast('Transaction is success!', { appearance: "success" });
          refetchPaymentDetails()
        } else {
          addToast(`${res?.error?.message}`, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(`error`, { appearance: "error" });
      }).finally(()=>{
          setIsLoading(false)
          setOtp("");
          setRemarks("")
          setOtpIsSuccess(false);   
          const uid = generateUniqueId()
          setReceiverData({
            ...receiverData,
            uniqueId:uid
          })       
      });
  }

  const handleVerifyBtn = ()=>{
    const data = {
      aggrId: senderData?.aggrId,
      aggrName: senderData?.aggrName,
      corpId: senderData?.corpId,
      userId: senderData?.userId,
      urn: senderData?.urn,
      uniqueId: receiverData?.uniqueId,
      payeeName:receiverData?.payeeName,
      amount:requestedAmount,
      debitAcc:senderData?.debitAcc,
      creditAcc:receiverData?.creditAcc,
      creditIfsc:receiverData?.ifsc,
      otp:otp,
      method:method,
      remarks:remarks,
      vendorBankId:bankValue,
      expense:{
        poNo:poNo,
        orderDate,
        vendorId,
        expenseId,
        moduleId,
        paymentId,
        expenseType,
        autoCount
      }
    }

    const validationResult = validateTranscationOtpField(data);
    if (!validationResult.isValid) {
      addToast(validationResult.message, { appearance: "error" });
      return; 
    }

    ConfirmationDialog({
      title: "Are you sure?",
      text: `You are about to proceed with a payment of ₹ ${formatAmountIndianRupees(
        requestedAmount
      )}. This action cannot be undone.`,
      icon: "warning",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: (e) => {
        fetchVerifyOtpApi(data);
      },
    });
  }

  function handleRemarks(e) {
    const value = e.target.value || "";
    const filteredValue = value.replace(/[^a-zA-Z0-9\s.,]/g, '');
    setRemarks(filteredValue);
  }

  const isAnyFieldEmpty = () => {
    const receiverFields = Object.values(receiverData);
    const senderFields = Object.values(senderData);
    return [...receiverFields, ...senderFields].some(field => field === "");
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        className="modal-main"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          className="add-form-modal-content"
          top="0"
          margin="0 auto"
          bottom="0"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              Pay Now - <span className="header-pr">{poNumberFormate(poNo)}</span>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {((isLoading || isOtpLoading || isLoadingInquiry)) ? (
            <SpinnerLoader />
          ) : (
            <ModalBody className="mt-4">
                <h3 className="remaining-heading">Remaining Payment Details </h3>
              <Box className="limit-section" display="flex">
                <div className="limit-div">
                <h3>Overall</h3>

              <ul className="overall-limit">
                <li>Daily Remaining: <span className="amount-text">₹ {formatAmountIndianRupees(limits?.overall?.remainingDaily) || Number(0).toFixed(2)}</span></li>
                <li>Monthly Remaining: <span className="amount-text">₹ {formatAmountIndianRupees(limits?.overall?.remainingMonthly) || Number(0).toFixed(2)}</span></li>
              </ul>
                </div >
              
                <div className="mx-3 limit-div">
                  <h3>{expenseType} </h3>
                  <ul className="overall-limit">
                  <li>Daily Remaining: <span className="amount-text">₹ {formatAmountIndianRupees(limits?.module?.remainingDaily) || Number(0).toFixed(2)}</span></li>
                  <li>Monthly Remaining: <span className="amount-text">₹ {formatAmountIndianRupees(limits?.module?.remainingMonthly) || Number(0).toFixed(2)}</span></li>
                  </ul>
                </div>
              </Box>
              <div class="payment-amount">
                Amount: ₹ {formatAmountIndianRupees(requestedAmount)}
              </div>
              <Box className="detail-sections">
              
                <section className="details-section" aria-label="Sender Details">
                  <h3>Paid By</h3>
                  <table className="pay-now-details-table">
                    <tr>
                      <th className="border-right">Detail</th>
                      <th>Information</th>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>CORPID #</strong>
                      </td>
                      <td>{senderData?.corpId || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>USERID #</strong>
                      </td>
                      <td>{senderData?.userId || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>AGGRID #</strong>
                      </td>
                      <td>{senderData?.aggrId || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>AGGRNAME</strong>
                      </td>
                      <td>{senderData?.aggrName || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>URN</strong>
                      </td>
                      <td>{senderData?.urn || "-"}</td>
                    </tr>

                    <tr>
                      <td className="border-right">
                        <strong>DEBITACC</strong>
                      </td>
                      <td>
                        {maskedAccNumber(senderData?.debitAcc) || "-"}
                      </td>
                    </tr>
                  </table>
                </section>

                <section className="details-section" aria-label="Receiver Details">
                  <Box display="flex">
                    <h3>Paid To</h3>
                    <SelectField
                      customClass="mx-4 mt-2"
                      name="Bank"
                      isDisabled={paymentData?._id}
                      options={bankOptions}
                      value={bankValue}
                      handleChange={(e)=>setBankValue(e?.target?.value)}
                    />
                  </Box>
                  <table className="pay-now-details-table">
                    <tr>
                      <th className="border-right">Detail</th>
                      <th>Information</th>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>UNIQUEID #</strong>
                      </td>
                      <td>{paymentData?.unqId ? paymentData?.unqId :receiverData?.uniqueId || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>PAYEENAME</strong>
                      </td>
                      <td>{receiverData?.payeeName || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>CREDITACC</strong>
                      </td>
                      <td>
                        {maskedAccNumber(receiverData?.creditAcc) || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>IFSC</strong>
                      </td>
                      <td>{receiverData?.ifsc || "-"}</td>
                    </tr>
                    <tr>
                      <td className="border-right">
                        <strong>AMOUNT </strong>
                      </td>
                      <td>
                        <b>₹ {formatAmountIndianRupees(requestedAmount)}</b>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-right">-</td>
                      <td>-</td>
                    </tr>
                  </table>
                </section>
              </Box>
              {paymentData?._id && paymentData?.sts ? 
              <section className="payment-details-section">
                 <div className="payment-details-header">
            <h3>Payment Detail</h3>
            {paymentData && (paymentData?.sts !== 'SUCCESS' && paymentData?.sts !== 'FAILURE') &&
            <button
              className="refresh-button"
              onClick={() => {
                if (typeof fetchTransactionInquiry === 'function') {
                  fetchTransactionInquiry();
                }
              }}
              aria-label="Refresh Payment Details"
              title="Refresh Payment Details"
            >
              <RiRefreshLine/>
            </button>
            }
          </div>
                  <table className="pay-now-details-table">
                    <thead>
                    <tr>
                      <th className="border-right">PoNo</th>
                      <th className="border-right">Req ID</th>
                      <th className="border-right">UTR No</th>
                      <th className="border-right">Amount</th>
                      <th className="border-right">Unique ID</th>
                      <th className="border-right">Status</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr>
                      <td className="border-right">
                        <strong>{paymentData?.poNo}</strong>
                      </td>
                      <td className="border-right">{paymentData?.reqId || "-"}</td>
                      <td className="border-right">{paymentData?.utr || "-"}</td>
                      <td className="border-right"> ₹ {formatAmountIndianRupees(paymentData?.amt || 0) || "-"}</td>

                      <td className="border-right">{paymentData?.unqId || "-"}</td>
                      <td className="border-right"><b>{paymentData?.sts || "-"}</b></td>

                    </tr>
                    </tbody>
                  </table>
              </section>
              :
              <Form className="paynow-form">
                <Row>
                  <Col>
                    <Box display="flex" className="input-box mb-3">
                      <Form.Label><span className="span-star">Transaction Method*</span></Form.Label>
                      <CustomPopover popoverText={prJson.pop.txnMethod} />
                      <Form.Select
                        name="method"
                        value={method}
                        onChange={(e) => setMethod(e?.target?.value)}
                        className="custom--dropdown-container pay-input"
                      >
                        {txnTypeMethod.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Select>

                    </Box>
                  </Col>
                  <Col></Col>
                </Row>
                {otpIsSuccess &&
                <Row>
                  <Col>
                    <Box display="flex" className="input-box mb-3">
                      <Form.Label>
                        <span className="span-star">Enter OTP*</span>{" "}
                      <CustomPopover popoverText={prJson.pop.otp} />
                      </Form.Label>
                      <Form.Control
                        name="otp"
                        type="number"
                        className="pay-input"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e?.target?.value)}
                      />

                    </Box>
                  </Col>
                  <Col></Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="span-star">Remarks*</span>
                    </Form.Label>

                    <Form.Control
                      as="textarea" // Change input to textarea
                      rows={2}
                      className=""
                      name="remarks"
                      placeholder="Type Here..."
                      value={remarks}
                      onChange={handleRemarks}
                    />
                  </Box>
                </Row>
                }
              </Form>
              }
            </ModalBody>
          )}
          <ModalFooter style={{ borderTop: "1px solid " }}>
            <div
              className="proceed-btn-group"
              role="group"
              aria-label="Payment actions"
            >
              {
              !paymentData?._id && !paymentData?.sts &&
              <>
              {!otpIsSuccess ?
              <button
                className="proceed-button"
                id="proceedBtn"
                type="button"
                disabled={isLoading || !method || isAnyFieldEmpty()}
                onClick={() => {
                  handleProcedBtn()
                }}
              >
                Proceed
              </button>
              :
              <button
                className="proceed-button"
                id="proceedBtn"
                type="button"
                disabled={isLoading}
                onClick={() => {
                  handleVerifyBtn()
                }}
              >
                Verify
              </button>
              }
              </>
              }
              <button
                disabled={isLoading}
                className="cancel-btn"
                id="cancelBtn"
                type="button"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PayNowDetails;
